import React from 'react';
import SectionHeader from './SectionHeader';
import CurrencyInput from './CurrencyInput';
import NotesInput from './NotesInput';
import AutoCheckbox from './AutoCheckbox';

/**
 * Section 6 — Insurance (life, LTC, disability, umbrella)
 *
 * Auto/home/medical insurance are captured in their respective sections.
 */
export default function StepInsurance({ data = {}, onChange }) {
  function set(field, value) {
    onChange({ ...data, [field]: value });
  }

  const rows = [
    { key: 'life_insurance', autoKey: 'life_insurance_auto', label: 'Life Insurance (Term, Universal, etc.)' },
    { key: 'long_term_care', autoKey: 'long_term_care_auto', label: 'Long-Term Care Insurance' },
    { key: 'disability', autoKey: 'disability_auto', label: 'Disability Insurance (Long-Term / Short-Term)' },
    { key: 'umbrella', autoKey: 'umbrella_auto', label: 'Umbrella Insurance' },
    { key: 'other_insurance', autoKey: 'other_insurance_auto', label: 'Other Insurance' },
  ];

  const total = rows.reduce((sum, r) => sum + (Number(data[r.key]) || 0), 0);

  return (
    <div>
      <SectionHeader
        number={6}
        title="Insurance"
        tip="List premiums you pay yourself - If a premium is automatically deducted from wages, check the AUTO box to have our team review your payslip for figures.
          Auto, home, and health insurance are already captured in earlier sections."
      />

      <div className="alert alert-light border small mb-4">
        <strong>Note:</strong> Auto Insurance → Auto &amp; Transport section |
        Homeowners / Renters → Housing section |
        Dental / Medical / Vision → Medical section
      </div>

      {rows.map(({ key, autoKey, label }) => (
        <div key={key} className="mb-3 pb-2 border-bottom">
          <CurrencyInput
            id={key}
            label={label}
            value={data[key] ?? null}
            onChange={(val) => set(key, val)}
          />
          <AutoCheckbox
            id={`${autoKey}_check`}
            checked={!!data[autoKey]}
            onChange={(val) => set(autoKey, val)}
          />
        </div>
      ))}

      {total > 0 && (
        <div className="cashflow-total-box mt-3">
          <span className="fw-semibold">6: Total Insurance Expenses</span>
          <span className="cashflow-total-amount">
            ${total.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
          </span>
        </div>
      )}

      <NotesInput value={data.notes} onChange={(val) => set('notes', val)} />
    </div>
  );
}
